import { render, staticRenderFns } from "./XZStorageAbandoned.vue?vue&type=template&id=bee5421c&"
import script from "@/scripts/gpuHub/gpuhubSync/xzStorageAbandoned.js?vue&type=script&lang=js&"
export * from "@/scripts/gpuHub/gpuhubSync/xzStorageAbandoned.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports